import { Component } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { ContainerRegistryRouterProps } from '../ContainerRegistryRouterProps';
import { ContainerRegistryEntities } from '../ContainerRegistryEntities';
import { ContainerRegistryLayout } from '../ContainerRegistryLayout';

export interface ContainerRegistryListPageProps extends NSARouterMakerResult, ContainerRegistryRouterProps { }

class ContainerRegistryListPage extends Component<ContainerRegistryListPageProps>
{
    override render()
    {
        return (
            <ContainerRegistryLayout
                {...this.props}
                pages={{
                    entity: ContainerRegistryEntities.container_registry(this.props),
                    list: {},
                }}
            >
                <></>
            </ContainerRegistryLayout>
        )
    }
}

export default ContainerRegistryListPage;